/* eslint-disable no-undef */
import React, { Component } from 'react';
import '../../css/match-summary.css';
import classnames from 'classnames';

class MatchSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
        };
        this.order = [0, 120];
        this.partialScores = {
            firstHalf: [0, 0],
            secondHalf: [0, 0],
            extraTimeFirstHalf: [0, 0],
            extraTimeSecondHalf: [0, 0],
        }
        this.computePartialScores();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.events !== this.props.data.events) {
            this.computePartialScores();
        }
    }

    computePartialScores() {
        this.props.data.events.forEach(event => {
            if (['G', 'PG', 'OG'].includes(event.code)) {
                if (event.minute <= 45) {
                    this.savePartialScore(event, 'firstHalf');
                } else if (event.minute <= 90) {
                    this.savePartialScore(event, 'secondHalf');
                } else if (event.minute <= 105) {
                    this.savePartialScore(event, 'extraTimeFirstHalf');
                } else if (event.minute <= 120) {
                    this.savePartialScore(event, 'extraTimeSecondHalf');
                }
            }
        })
    }

    savePartialScore(event, key) {
        let homeAwayIndex = -1;
        if (event.team_id === this.props.data.team_A_id) {
            if (event.code === 'OG') {
                homeAwayIndex = 1;
            } else {
                homeAwayIndex = 0;
            }
        } else if (event.team_id === this.props.data.team_B_id) {
            if (event.code === 'OG') {
                homeAwayIndex = 0;
            } else {
                homeAwayIndex = 1;
            }
        }
        if (homeAwayIndex !== -1) {
            this.partialScores[key][homeAwayIndex] = this.partialScores[key][homeAwayIndex] + 1;
        }
    }

    printEvents(goalArray, minuteFrom, minuteUntil, allowedCodes) {
        return (
            goalArray
                .sort((a, b) => {
                    return ((a.minute - b.minute) + (a.minute_extra - b.minute_extra));
                })
                .map(event => {
                    const shouldPrint = (
                        allowedCodes.includes(event.code)
                        && event.minute > minuteFrom
                        && event.minute <= minuteUntil
                    );
                    let align = (event.team_id === this.props.data.team_A_id ? 'left' : (event.team_id === this.props.data.team_B_id ? 'right' : ''));

                    // OWN GOAL alignment
                    if (event.code === 'OG') {
                        align === 'left' ? align = 'right' : align = 'left'
                    }
                    return (
                        (shouldPrint) && (
                            <div className={classnames(align, event.code === 'SO' && 'minorText')} key={event.event_id}>
                                <span className="goal-minute">{this.renderEventMinute(event.minute, event.minute_extra)}</span>
                                &nbsp;
                                &nbsp;
                                {this.printIcon(event.code)}
                                &nbsp;
                                &nbsp;
                                <span className="goal-person">{event.person}</span>
                            </div>
                        )
                    )
                })
        )
    }

    renderEventMinute(minute, minuteExtra) {
        let result = minute.toString();
        if (typeof minuteExtra !== "undefined" && minuteExtra !== 0 && minuteExtra !== '') {
            result = result + "+" + minuteExtra.toString();
        }
        result = result + "'";
        return result
    }

    printIcon(eventCode) {
        switch (eventCode) {
            case 'G':
                return <img className="golos" title="GOAL" src="/img/football.png" alt="" />
            case 'PG':
                return <img className="golos" title="Penalty GOAL" src="/img/football.png" alt="" />
            case 'OG':
                return <img className="golos" title="Auto Golo" src="/img/redball.png" alt="" />
            case 'PSM':
                return <img className="golos" title="Penalty falhado" src="/img/redball.png" alt="" />
            case 'PSG':
                return <img className="golos" title="Penalty GOAL" src="/img/football.png" alt="" />
            case 'YC':
                return <img className="cards" title="Amarelo" src="/img/YC.png" alt="" />
            case 'Y2C':
                return <img className="cards" title="Segundo Amarelo" src="/img/Y2C.png" alt="" />
            case 'RC':
                return <img className="cards" title="Vermelho" src="/img/RC.png" alt="" />
            case 'SI':
                return <img className="subs" title="Entrou" src="/img/SI.svg" alt="" width="23" height="23" />
            case 'SO':
                return <img className="subs" title="Saiu" src="/img/SO.svg" alt="" width="23" height="23" />
            default:
                return null;
        }
    }


    render() {
        return (
            <div className="match-summary">
                <div className="title-summary">
                    <span className="ball">
                        <img src="/img/summary.svg" alt="match summary" width="20" />
                    </span>
                    <h2>Sumário do Jogo</h2>
                </div>
                <div className={classnames("div-summary", !this.state.open && 'd-none')}>
                    <div className="div-first-half">
                        {
                            this.props.data.fs_A !== '' &&
                            this.props.data.fs_B !== '' &&
                            <div className="stat-first-half">
                                <span>
                                    <p colSpan="7">1º Parte<br />
                                        {this.partialScores.firstHalf[0]} - {this.partialScores.firstHalf[1]}</p>
                                </span>
                            </div>
                        }
                        <div className="stat-half-padding">
                            <span className="stats-first-half">
                                {this.printEvents(this.props.data.events, 0, 45, ['G', 'OG', 'PG', 'YC', 'Y2C', 'RC', 'PSM', 'SI', 'SO'])}
                            </span>
                        </div>
                    </div>
                    <div className="div-second-half">
                        {
                            this.props.data.fs_A !== '' &&
                            this.props.data.fs_B !== '' &&
                            <div className="stat-second-half">
                                <span>
                                    <p colSpan="7">2º Parte<br />
                                        {this.partialScores.secondHalf[0]} - {this.partialScores.secondHalf[1]}</p>
                                </span>
                            </div>
                        }
                        <div className="stat-half-padding2">
                            <span className="stats-second-half">
                                {this.printEvents(this.props.data.events, 45, 90, ['G', 'OG', 'PG', 'YC', 'Y2C', 'RC', 'SI', 'SO'])}
                            </span>
                        </div>
                        <div className="prolResult">{this.props.data.fs_A} - {this.props.data.fs_B}</div>
                    </div>
                    {
                        this.props.data.ets_A !== '' &&
                        this.props.data.ets_B !== '' &&
                        <div className="div-extratime">
                            <div className="stat-extratime">
                                <span>
                                    <p colSpan="7">Prolongamento <br />
                                        <span>{this.props.data.ets_A} - {this.props.data.ets_B}</span>
                                    </p>
                                </span>
                            </div>
                            <div className="stat-extratime-padding2">
                                <span className="stats-extratime">
                                    {this.printEvents(this.props.data.events, 90, 120, ['G', 'OG', 'PG', 'YC', 'Y2C', 'RC', 'SI', 'SO'])}
                                </span>
                            </div>
                        </div>
                    }
                    {
                        this.props.data.ps_A !== '' &&
                        this.props.data.ps_B !== '' &&
                        <div className="div-penalidades">
                            <div className="stat-penalidades">
                                <span>
                                    <p colSpan="7">Penalidades <br />
                                        <span>{this.props.data.ps_A} - {this.props.data.ps_B}</span>
                                    </p>
                                </span>
                            </div>
                            <div className="stat-penalidades-padding2" >
                                <span className="stats-penalidades">
                                    {this.printEvents(this.props.data.events, 0, 120, ['PSG', 'PSM'])}
                                </span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default MatchSummary;